import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/text-cursor-input.vue
var o = {
	name: "DtIconTextCursorInput",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--text-cursor-input"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Text Cursor Input",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M2 2a.5.5 0 0 1 .5-.5H3a2 2 0 0 1 1.5.677A2 2 0 0 1 6 1.5h.5a.5.5 0 0 1 0 1H6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h.5a.5.5 0 0 1 0 1H6a2 2 0 0 1-1.5-.677A2 2 0 0 1 3 10.5h-.5a.5.5 0 0 1 0-1H3a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-.5A.5.5 0 0 1 2 2Zm.032 1.45H2.4a.5.5 0 0 1 0 1h-.34a.59.59 0 0 0-.56.56v1.98a.59.59 0 0 0 .56.56h.34a.5.5 0 0 1 0 1h-.368A1.59 1.59 0 0 1 .5 7V4.982A1.59 1.59 0 0 1 2.032 3.45Zm4.018.5a.5.5 0 0 1 .5-.5h3.418A1.59 1.59 0 0 1 11.5 5v2.002A1.555 1.555 0 0 1 9.952 8.55H6.55a.5.5 0 0 1 0-1h3.399a.555.555 0 0 0 .551-.551V5.01a.59.59 0 0 0-.56-.56H6.55a.5.5 0 0 1-.5-.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=text-cursor-input.js.map